module.exports = __webpack_public_path__ + "7ce76a4271b41f8a05eb146fd83e4098.pdf";